import styled from 'styled-components';

export const TabItem = styled.div`
  margin: 15px 0px;
  width: 100%;
`;

export const TabItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 370px;
  padding: 75px;
`;

export const TabHintText = styled.div`
  font-size: 1.1rem;
  text-align: center;
  color: #000;
`;